"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/.pnpm/fetch-retry@6.0.0/node_modules/fetch-retry/index.js
var require_fetch_retry = __commonJS({
  "../../node_modules/.pnpm/fetch-retry@6.0.0/node_modules/fetch-retry/index.js"(exports2, module2) {
    "use strict";
    module2.exports = function(fetch2, defaults) {
      defaults = defaults || {};
      if (typeof fetch2 !== "function") {
        throw new ArgumentError("fetch must be a function");
      }
      if (typeof defaults !== "object") {
        throw new ArgumentError("defaults must be an object");
      }
      if (defaults.retries !== void 0 && !isPositiveInteger(defaults.retries)) {
        throw new ArgumentError("retries must be a positive integer");
      }
      if (defaults.retryDelay !== void 0 && !isPositiveInteger(defaults.retryDelay) && typeof defaults.retryDelay !== "function") {
        throw new ArgumentError("retryDelay must be a positive integer or a function returning a positive integer");
      }
      if (defaults.retryOn !== void 0 && !Array.isArray(defaults.retryOn) && typeof defaults.retryOn !== "function") {
        throw new ArgumentError("retryOn property expects an array or function");
      }
      var baseDefaults = {
        retries: 3,
        retryDelay: 1e3,
        retryOn: []
      };
      defaults = Object.assign(baseDefaults, defaults);
      return function fetchRetry2(input, init) {
        var retries = defaults.retries;
        var retryDelay = defaults.retryDelay;
        var retryOn2 = defaults.retryOn;
        if (init && init.retries !== void 0) {
          if (isPositiveInteger(init.retries)) {
            retries = init.retries;
          } else {
            throw new ArgumentError("retries must be a positive integer");
          }
        }
        if (init && init.retryDelay !== void 0) {
          if (isPositiveInteger(init.retryDelay) || typeof init.retryDelay === "function") {
            retryDelay = init.retryDelay;
          } else {
            throw new ArgumentError("retryDelay must be a positive integer or a function returning a positive integer");
          }
        }
        if (init && init.retryOn) {
          if (Array.isArray(init.retryOn) || typeof init.retryOn === "function") {
            retryOn2 = init.retryOn;
          } else {
            throw new ArgumentError("retryOn property expects an array or function");
          }
        }
        return new Promise(function(resolve, reject) {
          var wrappedFetch = function(attempt) {
            var _input = typeof Request !== "undefined" && input instanceof Request ? input.clone() : input;
            fetch2(_input, init).then(function(response) {
              if (Array.isArray(retryOn2) && retryOn2.indexOf(response.status) === -1) {
                resolve(response);
              } else if (typeof retryOn2 === "function") {
                try {
                  return Promise.resolve(retryOn2(attempt, null, response)).then(function(retryOnResponse) {
                    if (retryOnResponse) {
                      retry(attempt, null, response);
                    } else {
                      resolve(response);
                    }
                  }).catch(reject);
                } catch (error) {
                  reject(error);
                }
              } else {
                if (attempt < retries) {
                  retry(attempt, null, response);
                } else {
                  resolve(response);
                }
              }
            }).catch(function(error) {
              if (typeof retryOn2 === "function") {
                try {
                  Promise.resolve(retryOn2(attempt, error, null)).then(function(retryOnResponse) {
                    if (retryOnResponse) {
                      retry(attempt, error, null);
                    } else {
                      reject(error);
                    }
                  }).catch(function(error2) {
                    reject(error2);
                  });
                } catch (error2) {
                  reject(error2);
                }
              } else if (attempt < retries) {
                retry(attempt, error, null);
              } else {
                reject(error);
              }
            });
          };
          function retry(attempt, error, response) {
            var delay = typeof retryDelay === "function" ? retryDelay(attempt, error, response) : retryDelay;
            setTimeout(function() {
              wrappedFetch(++attempt);
            }, delay);
          }
          wrappedFetch(0);
        });
      };
    };
    function isPositiveInteger(value) {
      return Number.isInteger(value) && value >= 0;
    }
    function ArgumentError(message) {
      this.name = "ArgumentError";
      this.message = message;
    }
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  APIOfflineError: () => APIOfflineError,
  APIOwnFetchError: () => APIOwnFetchError,
  AccessRole: () => AccessRole,
  CMSTemplateObjectReviewState: () => CMSTemplateObjectReviewState,
  DesignSortType: () => DesignSortType,
  FolderSortType: () => FolderSortType,
  InvitableResourceTypes: () => InvitableResourceTypes,
  KittlHeaderNames: () => KittlHeaderNames,
  PathsAiartIndexGetParametersQuerySort: () => PathsAiartIndexGetParametersQuerySort,
  PathsAiartIndexGetParametersQueryStyleId: () => PathsAiartIndexGetParametersQueryStyleId,
  PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState: () => PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState,
  PathsAiartSearchGetParametersQueryType: () => PathsAiartSearchGetParametersQueryType,
  PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName: () => PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName,
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType: () => PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType,
  PathsChallengesList_submissionsGetParametersQuerySort: () => PathsChallengesList_submissionsGetParametersQuerySort,
  PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType: () => PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType,
  PathsCmsTemplatesIndexPostParametersQuerySortBy: () => PathsCmsTemplatesIndexPostParametersQuerySortBy,
  PathsCmsTemplatesIndexPostParametersQuerySortOrder: () => PathsCmsTemplatesIndexPostParametersQuerySortOrder,
  PathsCmsWorkspacesIndexGetParametersQueryType: () => PathsCmsWorkspacesIndexGetParametersQueryType,
  PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType: () => PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType,
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction: () => PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction,
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus: () => PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus,
  PathsCollaborationInvitesGetParametersQueryResourceType: () => PathsCollaborationInvitesGetParametersQueryResourceType,
  PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole: () => PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole,
  PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType: () => PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType,
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone: () => PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone,
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonType: () => PathsCopilotGenerateTextPostRequestBodyApplicationJsonType,
  PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing: () => PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing,
  PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole: () => PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole,
  PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole: () => PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole,
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji: () => PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji,
  PathsDesignsDesignIdThreadsGetParametersQueryFilter: () => PathsDesignsDesignIdThreadsGetParametersQueryFilter,
  PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType: () => PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType,
  PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel: () => PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel,
  PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat: () => PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat,
  PathsElementsUsePostRequestBodyApplicationJsonElementType: () => PathsElementsUsePostRequestBodyApplicationJsonElementType,
  PathsElementsUsePostRequestBodyApplicationJsonFeature: () => PathsElementsUsePostRequestBodyApplicationJsonFeature,
  PathsFeature_groupsAddPostResponses404ContentApplicationJsonError: () => PathsFeature_groupsAddPostResponses404ContentApplicationJsonError,
  PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType: () => PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType,
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend: () => PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend,
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin: () => PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin,
  PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio: () => PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio,
  PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus: () => PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus,
  PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver: () => PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver,
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType: () => PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType,
  PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort: () => PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort,
  PathsPathsCreatePostRequestBodyApplicationJsonType: () => PathsPathsCreatePostRequestBodyApplicationJsonType,
  PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode: () => PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode,
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName: () => PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName,
  PathsPostsForYouGetParametersQueryAlgorithm: () => PathsPostsForYouGetParametersQueryAlgorithm,
  PathsPostsV1ExploreGetParametersQuerySort: () => PathsPostsV1ExploreGetParametersQuerySort,
  PathsProductsIndexGetParametersQueryType: () => PathsProductsIndexGetParametersQueryType,
  PathsProductsIndexGetResponses200ContentApplicationJsonProductsType: () => PathsProductsIndexGetResponses200ContentApplicationJsonProductsType,
  PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType: () => PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType,
  PathsResourcesSharedGetParametersQueryResourceType: () => PathsResourcesSharedGetParametersQueryResourceType,
  PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable: () => PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable,
  PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan: () => PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan,
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry: () => PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry,
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval: () => PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval,
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan: () => PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan,
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType: () => PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType,
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole: () => PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole,
  PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError: () => PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError,
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType: () => PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType,
  PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError: () => PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError,
  PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName: () => PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName,
  PostObjectType: () => PostObjectType,
  ResourcePermissions: () => ResourcePermissions,
  ResourceType: () => ResourceType,
  SubscriptionObjectFreeTrialStatus: () => SubscriptionObjectFreeTrialStatus,
  SubscriptionPlanObjectInterval: () => SubscriptionPlanObjectInterval,
  apiFetchClient: () => apiFetchClient,
  apiReactQueryClient: () => apiReactQueryClient,
  getWorkspaceById: () => getWorkspaceById,
  getWorkspaceMe: () => getWorkspaceMe,
  invalidateEndpointCache: () => invalidateCollaborationInvitesQuery,
  invalidateWorkspaceQuery: () => invalidateWorkspaceQuery,
  invalidateWorkspacesForUserQuery: () => invalidateWorkspacesForUserQuery,
  useBasicUserInfoQuery: () => useBasicUserInfoQuery,
  useCollaborationInvitesCreateMutation: () => useCollaborationInvitesCreateMutation,
  useCollaborationInvitesPatchMutation: () => useCollaborationInvitesPatchMutation,
  useCollaborationInvitesQuery: () => useCollaborationInvitesQuery,
  useCollaborationInvitesResendMutation: () => useCollaborationInvitesResendMutation,
  useCollaborationInvitesRevokeMutation: () => useCollaborationInvitesRevokeMutation,
  useCreateWorkspaceMutation: () => useCreateWorkspaceMutation,
  useCreditsInfo: () => useCreditsInfo,
  useDeleteNotification: () => useDeleteNotification,
  useDeleteWorkspaceMutation: () => useDeleteWorkspaceMutation,
  useFolders: () => useFolders,
  useProjects: () => useProjects,
  useRecentProjects: () => useRecentProjects,
  useResourcePermissionsQuery: () => useResourcePermissionsQuery,
  useSharedProjects: () => useSharedProjects,
  useUpdateWorkspaceMutation: () => useUpdateWorkspaceMutation,
  useWorkspaceQuery: () => useWorkspaceQuery,
  useWorkspacesForUserQuery: () => useWorkspacesForUserQuery,
  workspacesForUserQueryOptions: () => queryOptions
});
module.exports = __toCommonJS(src_exports);

// src/generated/schema.ts
var ResourceType = {
  /** @deprecated */
  presentations: "presentations",
  /** @deprecated */
  designs: "designs",
  /** @deprecated */
  threads: "threads",
  /** @deprecated */
  comments: "comments",
  /** @deprecated */
  invites: "invites",
  /** @deprecated */
  workspaces: "workspaces",
  workspace: "workspace",
  user: "user",
  design: "design",
  presentation: "presentation",
  comment: "comment",
  thread: "thread",
  invite: "invite"
};
var DesignSortType = {
  NAME: "NAME",
  RECENT: "RECENT",
  CREATED: "CREATED"
};
var FolderSortType = {
  NAME: "NAME",
  RECENT: "RECENT",
  CREATED: "CREATED"
};
var InvitableResourceTypes = {
  presentation: "presentation",
  design: "design",
  workspace: "workspace"
};
var AccessRole = {
  viewer: "viewer",
  editor: "editor",
  administrator: "administrator",
  owner: "owner",
  VIEWER: "VIEWER",
  EDITOR: "EDITOR"
};
var PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType = /* @__PURE__ */ ((PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2) => {
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["TEMPLATE"] = "TEMPLATE";
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["ELEMENT"] = "ELEMENT";
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["AIART"] = "AIART";
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["UNSPLASH"] = "UNSPLASH";
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["FREEPIK"] = "FREEPIK";
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["FONT_FAMILY"] = "FONT_FAMILY";
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2["CMS_FONT_FAMILY"] = "CMS_FONT_FAMILY";
  return PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType2;
})(PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType || {});
var PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole = /* @__PURE__ */ ((PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole2) => {
  PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole2["viewer"] = "viewer";
  PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole2["editor"] = "editor";
  PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole2["administrator"] = "administrator";
  PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole2["owner"] = "owner";
  return PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole2;
})(PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole || {});
var PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole = /* @__PURE__ */ ((PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole2) => {
  PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole2["VIEWER"] = "VIEWER";
  PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole2["viewer"] = "viewer";
  return PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole2;
})(PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole || {});
var PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing = /* @__PURE__ */ ((PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing2) => {
  PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing2["PRIVATE"] = "PRIVATE";
  PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing2["SHARED_VIA_LINK"] = "SHARED_VIA_LINK";
  PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing2["PUBLIC"] = "PUBLIC";
  return PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing2;
})(PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing || {});
var PathsDesignsDesignIdThreadsGetParametersQueryFilter = /* @__PURE__ */ ((PathsDesignsDesignIdThreadsGetParametersQueryFilter2) => {
  PathsDesignsDesignIdThreadsGetParametersQueryFilter2["all"] = "all";
  return PathsDesignsDesignIdThreadsGetParametersQueryFilter2;
})(PathsDesignsDesignIdThreadsGetParametersQueryFilter || {});
var PathsDesignsDesignIdThreadsGetParametersQueryFilter = /* @__PURE__ */ ((PathsDesignsDesignIdThreadsGetParametersQueryFilter2) => {
  PathsDesignsDesignIdThreadsGetParametersQueryFilter2["unresolved"] = "unresolved";
  return PathsDesignsDesignIdThreadsGetParametersQueryFilter2;
})(PathsDesignsDesignIdThreadsGetParametersQueryFilter || {});
var PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji = /* @__PURE__ */ ((PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2) => {
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u{1F44D}"] = "\u{1F44D}";
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u2764\uFE0F"] = "\u2764\uFE0F";
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u{1F389}"] = "\u{1F389}";
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u{1F525}"] = "\u{1F525}";
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u{1F602}"] = "\u{1F602}";
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u{1F622}"] = "\u{1F622}";
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2["\u{1F64F}"] = "\u{1F64F}";
  return PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji2;
})(PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji || {});
var PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType = /* @__PURE__ */ ((PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType2) => {
  PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType2["design"] = "design";
  return PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType2;
})(PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType || {});
var PathsPostsV1ExploreGetParametersQuerySort = /* @__PURE__ */ ((PathsPostsV1ExploreGetParametersQuerySort2) => {
  PathsPostsV1ExploreGetParametersQuerySort2["popularity"] = "popularity";
  PathsPostsV1ExploreGetParametersQuerySort2["recent"] = "recent";
  PathsPostsV1ExploreGetParametersQuerySort2["trending"] = "trending";
  PathsPostsV1ExploreGetParametersQuerySort2["name"] = "name";
  PathsPostsV1ExploreGetParametersQuerySort2["recommended"] = "recommended";
  return PathsPostsV1ExploreGetParametersQuerySort2;
})(PathsPostsV1ExploreGetParametersQuerySort || {});
var PathsPostsForYouGetParametersQueryAlgorithm = /* @__PURE__ */ ((PathsPostsForYouGetParametersQueryAlgorithm2) => {
  PathsPostsForYouGetParametersQueryAlgorithm2["internal"] = "internal";
  PathsPostsForYouGetParametersQueryAlgorithm2["external"] = "external";
  return PathsPostsForYouGetParametersQueryAlgorithm2;
})(PathsPostsForYouGetParametersQueryAlgorithm || {});
var PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError = /* @__PURE__ */ ((PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError2) => {
  PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError2["QUESTION_ALREADY_ANSWERED"] = "QUESTION_ALREADY_ANSWERED";
  return PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError2;
})(PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError || {});
var PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType = /* @__PURE__ */ ((PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2) => {
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2["UNLIMITED"] = "UNLIMITED";
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2["DAILY"] = "DAILY";
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2["MONTHLY"] = "MONTHLY";
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2["STANDARD"] = "STANDARD";
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2["MRC"] = "MRC";
  return PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType2;
})(PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType || {});
var PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName = /* @__PURE__ */ ((PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName2) => {
  PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName2["LAST_IMAGE_GEN_MODEL_USED"] = "LAST_IMAGE_GEN_MODEL_USED";
  PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName2["SEEN_FEATURE_HIGHLIGHTS"] = "SEEN_FEATURE_HIGHLIGHTS";
  PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName2["ERASE_AND_FILL_ACTIVE"] = "ERASE_AND_FILL_ACTIVE";
  PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName2["LAST_ADVANCED_IMAGE_GEN_MODEL_USED"] = "LAST_ADVANCED_IMAGE_GEN_MODEL_USED";
  return PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName2;
})(PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName || {});
var PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole = /* @__PURE__ */ ((PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2) => {
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["CREATOR"] = "CREATOR";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["CONTENT_MANAGER"] = "CONTENT_MANAGER";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["CONTENT_CREATOR"] = "CONTENT_CREATOR";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["ADMIN"] = "ADMIN";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["SUPPORT"] = "SUPPORT";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["REVENUE_SHARE"] = "REVENUE_SHARE";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["REVIEWER"] = "REVIEWER";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["TAXONOMY_EDITOR"] = "TAXONOMY_EDITOR";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["MOCKUP_MANAGER"] = "MOCKUP_MANAGER";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["AI_MANAGER"] = "AI_MANAGER";
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2["CHALLENGE_MANAGER"] = "CHALLENGE_MANAGER";
  return PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole2;
})(PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole || {});
var PathsFeature_groupsAddPostResponses404ContentApplicationJsonError = /* @__PURE__ */ ((PathsFeature_groupsAddPostResponses404ContentApplicationJsonError2) => {
  PathsFeature_groupsAddPostResponses404ContentApplicationJsonError2["FEATURE_GROUP_NOT_FOUND"] = "FEATURE_GROUP_NOT_FOUND";
  return PathsFeature_groupsAddPostResponses404ContentApplicationJsonError2;
})(PathsFeature_groupsAddPostResponses404ContentApplicationJsonError || {});
var PathsFeature_groupsAddPostResponses404ContentApplicationJsonError = /* @__PURE__ */ ((PathsFeature_groupsAddPostResponses404ContentApplicationJsonError2) => {
  PathsFeature_groupsAddPostResponses404ContentApplicationJsonError2["USER_NOT_FOUND"] = "USER_NOT_FOUND";
  return PathsFeature_groupsAddPostResponses404ContentApplicationJsonError2;
})(PathsFeature_groupsAddPostResponses404ContentApplicationJsonError || {});
var PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError = /* @__PURE__ */ ((PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError2) => {
  PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError2["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
  return PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError2;
})(PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError || {});
var PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable = /* @__PURE__ */ ((PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable2) => {
  PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable2["true"] = "true";
  PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable2["false"] = "false";
  return PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable2;
})(PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable || {});
var PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan = /* @__PURE__ */ ((PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan2) => {
  PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan2["FREE"] = "FREE";
  PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan2["PRO"] = "PRO";
  PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan2["EXPERT"] = "EXPERT";
  return PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan2;
})(PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan || {});
var PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode = /* @__PURE__ */ ((PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode2) => {
  PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode2["PREPAID_CARD_NOT_ACCEPTED"] = "PREPAID_CARD_NOT_ACCEPTED";
  PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode2["UNKNOWN"] = "UNKNOWN";
  return PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode2;
})(PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode || {});
var PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan = /* @__PURE__ */ ((PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan2) => {
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan2["PRO"] = "PRO";
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan2["EXPERT"] = "EXPERT";
  return PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan2;
})(PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan || {});
var PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval = /* @__PURE__ */ ((PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval2) => {
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval2["monthly"] = "monthly";
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval2["yearly"] = "yearly";
  return PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval2;
})(PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval || {});
var PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry = /* @__PURE__ */ ((PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry2) => {
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry2["US"] = "US";
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry2["EU"] = "EU";
  return PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry2;
})(PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry || {});
var PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType = /* @__PURE__ */ ((PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType2) => {
  PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["FONT"] = "FONT";
  return PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType2;
})(PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType || {});
var PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName = /* @__PURE__ */ ((PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName2) => {
  PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName2["dashboard"] = "dashboard";
  PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName2["checkout"] = "checkout";
  return PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName2;
})(PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName || {});
var PathsChallengesList_submissionsGetParametersQuerySort = /* @__PURE__ */ ((PathsChallengesList_submissionsGetParametersQuerySort2) => {
  PathsChallengesList_submissionsGetParametersQuerySort2["recent"] = "recent";
  PathsChallengesList_submissionsGetParametersQuerySort2["popular"] = "popular";
  return PathsChallengesList_submissionsGetParametersQuerySort2;
})(PathsChallengesList_submissionsGetParametersQuerySort || {});
var PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType = /* @__PURE__ */ ((PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType2) => {
  PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType2["folder"] = "folder";
  return PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType2;
})(PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType || {});
var PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin = /* @__PURE__ */ ((PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2) => {
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2["COPILOT"] = "COPILOT";
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2["RIGHT_PANEL"] = "RIGHT_PANEL";
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2["LEFT_PANEL"] = "LEFT_PANEL";
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2["MICRO_APP"] = "MICRO_APP";
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2["IMAGE_SETS"] = "IMAGE_SETS";
  return PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin2;
})(PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin || {});
var PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio = /* @__PURE__ */ ((PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio2) => {
  PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio2["square"] = "square";
  PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio2["horizontal"] = "horizontal";
  PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio2["vertical"] = "vertical";
  return PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio2;
})(PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio || {});
var PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus = /* @__PURE__ */ ((PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus2) => {
  PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus2["STARTED"] = "STARTED";
  PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus2["COMPLETE"] = "COMPLETE";
  PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus2["FAILED"] = "FAILED";
  return PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus2;
})(PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus || {});
var PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver = /* @__PURE__ */ ((PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2) => {
  PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2[PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2["Value0"] = 0] = "Value0";
  return PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2;
})(PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver || {});
var PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver = /* @__PURE__ */ ((PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2) => {
  PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2[PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2["Value1"] = 1] = "Value1";
  return PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver2;
})(PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver || {});
var PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend = /* @__PURE__ */ ((PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2) => {
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["AD_INPAINT"] = "AD_INPAINT";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["DALLE"] = "DALLE";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["DALLE_3"] = "DALLE_3";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["DALLE_CLIPART"] = "DALLE_CLIPART";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["DESIGN_GENERATOR"] = "DESIGN_GENERATOR";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["DESIGN_GENERATOR_V2"] = "DESIGN_GENERATOR_V2";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["ESRGAN"] = "ESRGAN";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["GPT_3_5"] = "GPT_3_5";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["GPT_4"] = "GPT_4";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["GPT_4_O"] = "GPT_4_O";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["KANDINSKY_2"] = "KANDINSKY_2";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["KANDINSKY_2_2"] = "KANDINSKY_2_2";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["OPENJOURNEY"] = "OPENJOURNEY";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["PIXIAN"] = "PIXIAN";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["SDXL_FLASH"] = "SDXL_FLASH";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["SDXL_FLASH_IP_ADAPTER"] = "SDXL_FLASH_IP_ADAPTER";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["SDXL_FLASH_GEN_FILL"] = "SDXL_FLASH_GEN_FILL";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["SDXL_FLASH_STYLE_SWITCH"] = "SDXL_FLASH_STYLE_SWITCH";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["REPLICATE_GEN_FILL"] = "REPLICATE_GEN_FILL";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["VECTORIZER"] = "VECTORIZER";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["FLUX_1_1_PRO"] = "FLUX_1_1_PRO";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["FLUX_1_1_ULTRA"] = "FLUX_1_1_ULTRA";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["FLUX_1_1_ULTRA_RAW"] = "FLUX_1_1_ULTRA_RAW";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["FLUX_FILL_PRO"] = "FLUX_FILL_PRO";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["IDEOGRAM_2A"] = "IDEOGRAM_2A";
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2["STABLE_DIFFUSION_2_0_INPAINTING"] = "STABLE_DIFFUSION_2_0_INPAINTING";
  return PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend2;
})(PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend || {});
var PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType = /* @__PURE__ */ ((PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType2) => {
  PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType2["CLIPART"] = "CLIPART";
  PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType2["IMAGE"] = "IMAGE";
  PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType2["VECTOR"] = "VECTOR";
  return PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType2;
})(PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType || {});
var PathsAiartIndexGetParametersQuerySort = /* @__PURE__ */ ((PathsAiartIndexGetParametersQuerySort2) => {
  PathsAiartIndexGetParametersQuerySort2["TRENDING"] = "TRENDING";
  PathsAiartIndexGetParametersQuerySort2["MOST_USED"] = "MOST_USED";
  PathsAiartIndexGetParametersQuerySort2["NAME"] = "NAME";
  PathsAiartIndexGetParametersQuerySort2["RECENT"] = "RECENT";
  PathsAiartIndexGetParametersQuerySort2["CREATED"] = "CREATED";
  return PathsAiartIndexGetParametersQuerySort2;
})(PathsAiartIndexGetParametersQuerySort || {});
var PathsAiartIndexGetParametersQueryStyleId = /* @__PURE__ */ ((PathsAiartIndexGetParametersQueryStyleId2) => {
  PathsAiartIndexGetParametersQueryStyleId2["null"] = "null";
  return PathsAiartIndexGetParametersQueryStyleId2;
})(PathsAiartIndexGetParametersQueryStyleId || {});
var PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState = /* @__PURE__ */ ((PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState2) => {
  PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState2["REVIEW"] = "REVIEW";
  PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState2["PUBLISHED"] = "PUBLISHED";
  PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState2["PUBLISHED_EDITOR_ONLY"] = "PUBLISHED_EDITOR_ONLY";
  PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState2["DISMISSED"] = "DISMISSED";
  return PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState2;
})(PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState || {});
var PathsAiartSearchGetParametersQueryType = /* @__PURE__ */ ((PathsAiartSearchGetParametersQueryType2) => {
  PathsAiartSearchGetParametersQueryType2["RASTER"] = "RASTER";
  PathsAiartSearchGetParametersQueryType2["VECTOR"] = "VECTOR";
  return PathsAiartSearchGetParametersQueryType2;
})(PathsAiartSearchGetParametersQueryType || {});
var PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType = /* @__PURE__ */ ((PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType2) => {
  PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType2["UPCOMING_EVENTS"] = "UPCOMING_EVENTS";
  PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType2["STAFF_PICKS"] = "STAFF_PICKS";
  return PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType2;
})(PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType || {});
var PathsCmsTemplatesIndexPostParametersQuerySortBy = /* @__PURE__ */ ((PathsCmsTemplatesIndexPostParametersQuerySortBy2) => {
  PathsCmsTemplatesIndexPostParametersQuerySortBy2["name"] = "name";
  PathsCmsTemplatesIndexPostParametersQuerySortBy2["createdAt"] = "createdAt";
  PathsCmsTemplatesIndexPostParametersQuerySortBy2["publishedAt"] = "publishedAt";
  PathsCmsTemplatesIndexPostParametersQuerySortBy2["reviewedAt"] = "reviewedAt";
  return PathsCmsTemplatesIndexPostParametersQuerySortBy2;
})(PathsCmsTemplatesIndexPostParametersQuerySortBy || {});
var PathsCmsTemplatesIndexPostParametersQuerySortOrder = /* @__PURE__ */ ((PathsCmsTemplatesIndexPostParametersQuerySortOrder2) => {
  PathsCmsTemplatesIndexPostParametersQuerySortOrder2["asc"] = "asc";
  PathsCmsTemplatesIndexPostParametersQuerySortOrder2["desc"] = "desc";
  return PathsCmsTemplatesIndexPostParametersQuerySortOrder2;
})(PathsCmsTemplatesIndexPostParametersQuerySortOrder || {});
var PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType = /* @__PURE__ */ ((PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2) => {
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["FILL"] = "FILL";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["BORDER"] = "BORDER";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["TRANSFORMATION"] = "TRANSFORMATION";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["PHOTO_FILTER"] = "PHOTO_FILTER";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["SHADOW"] = "SHADOW";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["TEXT"] = "TEXT";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["TEXT_EFFECT"] = "TEXT_EFFECT";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["TEXT_DECORATION"] = "TEXT_DECORATION";
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2["COLOR_PALETTE"] = "COLOR_PALETTE";
  return PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType2;
})(PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType || {});
var PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort = /* @__PURE__ */ ((PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort2) => {
  PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort2["NAME"] = "NAME";
  PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort2["RECENT"] = "RECENT";
  PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort2["CREATED"] = "CREATED";
  return PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort2;
})(PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort || {});
var PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone = /* @__PURE__ */ ((PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2) => {
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2["casual"] = "casual";
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2["formal"] = "formal";
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2["fun"] = "fun";
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2["inspiring"] = "inspiring";
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2["motivational"] = "motivational";
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2["neutral"] = "neutral";
  return PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone2;
})(PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone || {});
var PathsCopilotGenerateTextPostRequestBodyApplicationJsonType = /* @__PURE__ */ ((PathsCopilotGenerateTextPostRequestBodyApplicationJsonType2) => {
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonType2["headline"] = "headline";
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonType2["paragraph"] = "paragraph";
  return PathsCopilotGenerateTextPostRequestBodyApplicationJsonType2;
})(PathsCopilotGenerateTextPostRequestBodyApplicationJsonType || {});
var PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType = /* @__PURE__ */ ((PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2) => {
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["EDITOR"] = "EDITOR";
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["TEMPLATE"] = "TEMPLATE";
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["ELEMENT"] = "ELEMENT";
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["MOCKUP"] = "MOCKUP";
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["TYPEFACE"] = "TYPEFACE";
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["COPILOT"] = "COPILOT";
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2["DESIGN_GEN"] = "DESIGN_GEN";
  return PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType2;
})(PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType || {});
var PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel = /* @__PURE__ */ ((PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel2) => {
  PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel2["free"] = "free";
  return PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel2;
})(PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel || {});
var PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel = /* @__PURE__ */ ((PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel2) => {
  PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel2["premium"] = "premium";
  return PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel2;
})(PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel || {});
var PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat = /* @__PURE__ */ ((PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat2) => {
  PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat2["vector"] = "vector";
  return PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat2;
})(PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat || {});
var PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat = /* @__PURE__ */ ((PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat2) => {
  PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat2["raster"] = "raster";
  return PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat2;
})(PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat || {});
var PathsElementsUsePostRequestBodyApplicationJsonElementType = /* @__PURE__ */ ((PathsElementsUsePostRequestBodyApplicationJsonElementType2) => {
  PathsElementsUsePostRequestBodyApplicationJsonElementType2["ELEMENT"] = "ELEMENT";
  PathsElementsUsePostRequestBodyApplicationJsonElementType2["AIART"] = "AIART";
  PathsElementsUsePostRequestBodyApplicationJsonElementType2["UNSPLASH"] = "UNSPLASH";
  PathsElementsUsePostRequestBodyApplicationJsonElementType2["FREEPIK"] = "FREEPIK";
  return PathsElementsUsePostRequestBodyApplicationJsonElementType2;
})(PathsElementsUsePostRequestBodyApplicationJsonElementType || {});
var PathsElementsUsePostRequestBodyApplicationJsonFeature = /* @__PURE__ */ ((PathsElementsUsePostRequestBodyApplicationJsonFeature2) => {
  PathsElementsUsePostRequestBodyApplicationJsonFeature2["COPILOT_ADD_TO_CANVAS"] = "COPILOT_ADD_TO_CANVAS";
  PathsElementsUsePostRequestBodyApplicationJsonFeature2["COPILOT_REPLACE_ELEMENT"] = "COPILOT_REPLACE_ELEMENT";
  PathsElementsUsePostRequestBodyApplicationJsonFeature2["ELEMENTS_TAB_ADD_TO_CANVAS"] = "ELEMENTS_TAB_ADD_TO_CANVAS";
  PathsElementsUsePostRequestBodyApplicationJsonFeature2["ELEMENTS_TAB_REPLACE_ELEMENT"] = "ELEMENTS_TAB_REPLACE_ELEMENT";
  PathsElementsUsePostRequestBodyApplicationJsonFeature2["STYLE_SWITCH"] = "STYLE_SWITCH";
  return PathsElementsUsePostRequestBodyApplicationJsonFeature2;
})(PathsElementsUsePostRequestBodyApplicationJsonFeature || {});
var PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName = /* @__PURE__ */ ((PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2) => {
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["frame_time_render_per_second_boards"] = "frame_time.render_per_second_boards";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["frame_time_dom_content_load_time"] = "frame_time.dom_content_load_time";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["frame_time_design_preview_visible_time"] = "frame_time.design_preview_visible_time";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["frame_time_project_load_time"] = "frame_time.project_load_time";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["number_of_artboards"] = "number_of.artboards";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["size_of_state"] = "size_of.state";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["PROJECT_CHANGE"] = "PROJECT_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["CREATE_NEW_PROJECT"] = "CREATE_NEW_PROJECT";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["COPY_SELECTION"] = "COPY_SELECTION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["PASTE_OBJECT"] = "PASTE_OBJECT";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ENTER_MOCKUP_MODE"] = "ENTER_MOCKUP_MODE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["MOCKUPS_PANEL_LOAD_TIME"] = "MOCKUPS_PANEL_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["MOCKUPS_PANEL_SEARCH_LOAD_TIME"] = "MOCKUPS_PANEL_SEARCH_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TOGGLE_LAYER_VISIBILITY"] = "TOGGLE_LAYER_VISIBILITY";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FONTS_LOAD_TIME"] = "FONTS_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["PHOTOS_LOAD_TIME"] = "PHOTOS_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["PHOTOS_SEARCH_LOAD_TIME"] = "PHOTOS_SEARCH_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_PHOTO_TO_BOARD"] = "ADD_PHOTO_TO_BOARD";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["CREATE_ARTBOARD"] = "CREATE_ARTBOARD";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["DUPLICATE_ARTBOARD"] = "DUPLICATE_ARTBOARD";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["DRAG_DUPLICATE"] = "DRAG_DUPLICATE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["VIEW_DOWNLOAD_PANEL"] = "VIEW_DOWNLOAD_PANEL";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["DOWNLOAD_ARTBOARDS"] = "DOWNLOAD_ARTBOARDS";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["DOWNLOAD_SELECTION"] = "DOWNLOAD_SELECTION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["DOWNLOAD_ITEM_PROCESSING"] = "DOWNLOAD_ITEM_PROCESSING";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["CHANGE_ALIGNMENT"] = "CHANGE_ALIGNMENT";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["CHANGE_ARRANGEMENT"] = "CHANGE_ARRANGEMENT";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEMPLATES_PANEL_LOAD_TIME"] = "TEMPLATES_PANEL_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEMPLATES_PANEL_SEARCH_LOAD_TIME"] = "TEMPLATES_PANEL_SEARCH_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_TEMPLATE"] = "ADD_TEMPLATE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_UPLOAD_TO_BOARD"] = "ADD_UPLOAD_TO_BOARD";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ELEMENTS_PANEL_LOAD_TIME"] = "ELEMENTS_PANEL_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ELEMENTS_PANEL_SEARCH_LOAD_TIME"] = "ELEMENTS_PANEL_SEARCH_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_ELEMENT"] = "ADD_ELEMENT";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEXTURES_PANEL_LOAD_TIME"] = "TEXTURES_PANEL_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEXTURES_PANEL_SEARCH_LOAD_TIME"] = "TEXTURES_PANEL_SEARCH_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["APPLY_TEXTURE"] = "APPLY_TEXTURE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["APPLY_BACKGROUND"] = "APPLY_BACKGROUND";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["LAYOUTS_PANEL_LOAD_TIME"] = "LAYOUTS_PANEL_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_TEXT_PRESET_TO_BOARD"] = "ADD_TEXT_PRESET_TO_BOARD";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_PARAGRAPH"] = "ADD_PARAGRAPH";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ADD_HEADLINE"] = "ADD_HEADLINE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEXT_TYPING"] = "TEXT_TYPING";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEXT_DECORATION"] = "TEXT_DECORATION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEXT_SHADING"] = "TEXT_SHADING";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["TEXT_TRANSFORMATION"] = "TEXT_TRANSFORMATION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FONT_FAMILY_CHANGE"] = "FONT_FAMILY_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["AI_IMAGE_GENERATION_TIME"] = "AI_IMAGE_GENERATION_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["AI_IMAGE_GENERATOR_STYLES_LOAD_TIME"] = "AI_IMAGE_GENERATOR_STYLES_LOAD_TIME";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["REMOVE_BACKGROUND"] = "REMOVE_BACKGROUND";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["IMAGE_VECTORIZER"] = "IMAGE_VECTORIZER";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["IMAGE_UPSCALER"] = "IMAGE_UPSCALER";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ACTIVE_SAVE_AS_STYLE"] = "ACTIVE_SAVE_AS_STYLE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["ROUND_CORNERS_UI"] = "ROUND_CORNERS_UI";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_PINCH_TO_ZOOM"] = "FRAME_TIME_PINCH_TO_ZOOM";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_TEXT_TRANSFORMATION"] = "FRAME_TIME_TEXT_TRANSFORMATION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_OBJECT_MOVE"] = "FRAME_TIME_OBJECT_MOVE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_OBJECT_RESIZE"] = "FRAME_TIME_OBJECT_RESIZE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_BORDER_WEIGHT_CHANGE"] = "FRAME_TIME_BORDER_WEIGHT_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_OPACITY_CHANGE"] = "FRAME_TIME_OPACITY_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_FONT_SIZE_CHANGE"] = "FRAME_TIME_FONT_SIZE_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_PHOTO_FILTER"] = "FRAME_TIME_PHOTO_FILTER";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_TEXT_SHADING"] = "FRAME_TIME_TEXT_SHADING";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_TEXT_DECORATION"] = "FRAME_TIME_TEXT_DECORATION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_OBJECT_ROTATE"] = "FRAME_TIME_OBJECT_ROTATE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_OBJECT_ERASE"] = "FRAME_TIME_OBJECT_ERASE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_IMAGE_MASK"] = "FRAME_TIME_IMAGE_MASK";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_OPT_DRAG_TO_COPY_SELECTION"] = "FRAME_TIME_OPT_DRAG_TO_COPY_SELECTION";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_PANNING"] = "FRAME_TIME_PANNING";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_ERASER_SIZE_CHANGE"] = "FRAME_TIME_ERASER_SIZE_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_COLOR_CHANGE"] = "FRAME_TIME_COLOR_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_IMAGE_BLEND_CHANGE"] = "FRAME_TIME_IMAGE_BLEND_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_COLOR_PALLETE_CHANGE"] = "FRAME_TIME_COLOR_PALLETE_CHANGE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_COLOR_PALLETE_PREVIEW"] = "FRAME_TIME_COLOR_PALLETE_PREVIEW";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_LAYERS_REORDER"] = "FRAME_TIME_LAYERS_REORDER";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_CROPPING"] = "FRAME_TIME_CROPPING";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_SHADOW_UPDATE"] = "FRAME_TIME_SHADOW_UPDATE";
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2["FRAME_TIME_ROUND_CORNERS_CONTROL"] = "FRAME_TIME_ROUND_CORNERS_CONTROL";
  return PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName2;
})(PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName || {});
var PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole = /* @__PURE__ */ ((PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole2) => {
  PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole2["VIEWER"] = "VIEWER";
  PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole2["EDITOR"] = "EDITOR";
  return PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole2;
})(PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole || {});
var PathsCollaborationInvitesGetParametersQueryResourceType = /* @__PURE__ */ ((PathsCollaborationInvitesGetParametersQueryResourceType2) => {
  PathsCollaborationInvitesGetParametersQueryResourceType2["presentation"] = "presentation";
  PathsCollaborationInvitesGetParametersQueryResourceType2["design"] = "design";
  PathsCollaborationInvitesGetParametersQueryResourceType2["workspace"] = "workspace";
  return PathsCollaborationInvitesGetParametersQueryResourceType2;
})(PathsCollaborationInvitesGetParametersQueryResourceType || {});
var PathsResourcesSharedGetParametersQueryResourceType = /* @__PURE__ */ ((PathsResourcesSharedGetParametersQueryResourceType2) => {
  PathsResourcesSharedGetParametersQueryResourceType2["workspace"] = "workspace";
  return PathsResourcesSharedGetParametersQueryResourceType2;
})(PathsResourcesSharedGetParametersQueryResourceType || {});
var PathsProductsIndexGetParametersQueryType = /* @__PURE__ */ ((PathsProductsIndexGetParametersQueryType2) => {
  PathsProductsIndexGetParametersQueryType2["CREDITS"] = "CREDITS";
  return PathsProductsIndexGetParametersQueryType2;
})(PathsProductsIndexGetParametersQueryType || {});
var PathsProductsIndexGetResponses200ContentApplicationJsonProductsType = /* @__PURE__ */ ((PathsProductsIndexGetResponses200ContentApplicationJsonProductsType2) => {
  PathsProductsIndexGetResponses200ContentApplicationJsonProductsType2["PRINTFUL"] = "PRINTFUL";
  PathsProductsIndexGetResponses200ContentApplicationJsonProductsType2["CREDITS"] = "CREDITS";
  return PathsProductsIndexGetResponses200ContentApplicationJsonProductsType2;
})(PathsProductsIndexGetResponses200ContentApplicationJsonProductsType || {});
var PathsPathsCreatePostRequestBodyApplicationJsonType = /* @__PURE__ */ ((PathsPathsCreatePostRequestBodyApplicationJsonType2) => {
  PathsPathsCreatePostRequestBodyApplicationJsonType2["ERASE_PATH"] = "ERASE_PATH";
  PathsPathsCreatePostRequestBodyApplicationJsonType2["VECTOR_EDIT_PATH"] = "VECTOR_EDIT_PATH";
  return PathsPathsCreatePostRequestBodyApplicationJsonType2;
})(PathsPathsCreatePostRequestBodyApplicationJsonType || {});
var PathsCmsWorkspacesIndexGetParametersQueryType = /* @__PURE__ */ ((PathsCmsWorkspacesIndexGetParametersQueryType2) => {
  PathsCmsWorkspacesIndexGetParametersQueryType2["workspaceName"] = "workspaceName";
  PathsCmsWorkspacesIndexGetParametersQueryType2["ownerEmail"] = "ownerEmail";
  return PathsCmsWorkspacesIndexGetParametersQueryType2;
})(PathsCmsWorkspacesIndexGetParametersQueryType || {});
var PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType = /* @__PURE__ */ ((PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType2) => {
  PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType2["USER"] = "USER";
  return PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType2;
})(PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType || {});
var PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus = /* @__PURE__ */ ((PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2) => {
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2["DRAFT"] = "DRAFT";
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2["TRIALING"] = "TRIALING";
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2["ACTIVE"] = "ACTIVE";
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2["CANCELED"] = "CANCELED";
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2["PAST_DUE"] = "PAST_DUE";
  return PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus2;
})(PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus || {});
var PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction = /* @__PURE__ */ ((PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction2) => {
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction2["CREATE"] = "CREATE";
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction2["UPDATE"] = "UPDATE";
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction2["CANCEL"] = "CANCEL";
  return PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction2;
})(PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction || {});
var PostObjectType = /* @__PURE__ */ ((PostObjectType2) => {
  PostObjectType2["TEMPLATE"] = "TEMPLATE";
  return PostObjectType2;
})(PostObjectType || {});
var SubscriptionPlanObjectInterval = /* @__PURE__ */ ((SubscriptionPlanObjectInterval2) => {
  SubscriptionPlanObjectInterval2["day"] = "day";
  SubscriptionPlanObjectInterval2["week"] = "week";
  SubscriptionPlanObjectInterval2["month"] = "month";
  SubscriptionPlanObjectInterval2["year"] = "year";
  return SubscriptionPlanObjectInterval2;
})(SubscriptionPlanObjectInterval || {});
var SubscriptionObjectFreeTrialStatus = /* @__PURE__ */ ((SubscriptionObjectFreeTrialStatus2) => {
  SubscriptionObjectFreeTrialStatus2["AVAILABLE"] = "AVAILABLE";
  SubscriptionObjectFreeTrialStatus2["RUNNING"] = "RUNNING";
  SubscriptionObjectFreeTrialStatus2["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
  SubscriptionObjectFreeTrialStatus2["PAID_BY_KITTL"] = "PAID_BY_KITTL";
  return SubscriptionObjectFreeTrialStatus2;
})(SubscriptionObjectFreeTrialStatus || {});
var CMSTemplateObjectReviewState = /* @__PURE__ */ ((CMSTemplateObjectReviewState2) => {
  CMSTemplateObjectReviewState2["pending"] = "pending";
  CMSTemplateObjectReviewState2["review"] = "review";
  CMSTemplateObjectReviewState2["reviewed"] = "reviewed";
  return CMSTemplateObjectReviewState2;
})(CMSTemplateObjectReviewState || {});

// ../../node_modules/.pnpm/openapi-fetch@0.13.4/node_modules/openapi-fetch/dist/index.js
var PATH_PARAM_RE = /\{[^{}]+\}/g;
var supportsRequestInitExt = () => {
  return typeof process === "object" && Number.parseInt(process?.versions?.node?.substring(0, 2)) >= 18 && process.versions.undici;
};
function randomID() {
  return Math.random().toString(36).slice(2, 11);
}
function createClient(clientOptions) {
  let {
    baseUrl = "",
    Request: CustomRequest = globalThis.Request,
    fetch: baseFetch = globalThis.fetch,
    querySerializer: globalQuerySerializer,
    bodySerializer: globalBodySerializer,
    headers: baseHeaders,
    requestInitExt = void 0,
    ...baseOptions
  } = { ...clientOptions };
  requestInitExt = supportsRequestInitExt() ? requestInitExt : void 0;
  baseUrl = removeTrailingSlash(baseUrl);
  const middlewares = [];
  async function coreFetch(schemaPath, fetchOptions) {
    const {
      baseUrl: localBaseUrl,
      fetch: fetch2 = baseFetch,
      Request: Request2 = CustomRequest,
      headers,
      params = {},
      parseAs = "json",
      querySerializer: requestQuerySerializer,
      bodySerializer = globalBodySerializer ?? defaultBodySerializer,
      body,
      ...init
    } = fetchOptions || {};
    if (localBaseUrl) {
      baseUrl = removeTrailingSlash(localBaseUrl);
    }
    let querySerializer = typeof globalQuerySerializer === "function" ? globalQuerySerializer : createQuerySerializer(globalQuerySerializer);
    if (requestQuerySerializer) {
      querySerializer = typeof requestQuerySerializer === "function" ? requestQuerySerializer : createQuerySerializer({
        ...typeof globalQuerySerializer === "object" ? globalQuerySerializer : {},
        ...requestQuerySerializer
      });
    }
    const serializedBody = body === void 0 ? void 0 : bodySerializer(body);
    const defaultHeaders = (
      // with no body, we should not to set Content-Type
      serializedBody === void 0 || // if serialized body is FormData; browser will correctly set Content-Type & boundary expression
      serializedBody instanceof FormData ? {} : {
        "Content-Type": "application/json"
      }
    );
    const requestInit = {
      redirect: "follow",
      ...baseOptions,
      ...init,
      body: serializedBody,
      headers: mergeHeaders(defaultHeaders, baseHeaders, headers, params.header)
    };
    let id;
    let options;
    let request = new CustomRequest(createFinalURL(schemaPath, { baseUrl, params, querySerializer }), requestInit);
    for (const key in init) {
      if (!(key in request)) {
        request[key] = init[key];
      }
    }
    if (middlewares.length) {
      id = randomID();
      options = Object.freeze({
        baseUrl,
        fetch: fetch2,
        parseAs,
        querySerializer,
        bodySerializer
      });
      for (const m of middlewares) {
        if (m && typeof m === "object" && typeof m.onRequest === "function") {
          const result = await m.onRequest({
            request,
            schemaPath,
            params,
            options,
            id
          });
          if (result) {
            if (!(result instanceof CustomRequest)) {
              throw new Error("onRequest: must return new Request() when modifying the request");
            }
            request = result;
          }
        }
      }
    }
    let response;
    try {
      response = await fetch2(request, requestInitExt);
    } catch (error2) {
      let errorAfterMiddleware = error2;
      if (middlewares.length) {
        for (let i = middlewares.length - 1; i >= 0; i--) {
          const m = middlewares[i];
          if (m && typeof m === "object" && typeof m.onError === "function") {
            const result = await m.onError({
              request,
              error: errorAfterMiddleware,
              schemaPath,
              params,
              options,
              id
            });
            if (result) {
              if (result instanceof Response) {
                errorAfterMiddleware = void 0;
                response = result;
                break;
              }
              if (result instanceof Error) {
                errorAfterMiddleware = result;
                continue;
              }
              throw new Error("onError: must return new Response() or instance of Error");
            }
          }
        }
      }
      if (errorAfterMiddleware) {
        throw errorAfterMiddleware;
      }
    }
    if (middlewares.length) {
      for (let i = middlewares.length - 1; i >= 0; i--) {
        const m = middlewares[i];
        if (m && typeof m === "object" && typeof m.onResponse === "function") {
          const result = await m.onResponse({
            request,
            response,
            schemaPath,
            params,
            options,
            id
          });
          if (result) {
            if (!(result instanceof Response)) {
              throw new Error("onResponse: must return new Response() when modifying the response");
            }
            response = result;
          }
        }
      }
    }
    if (response.status === 204 || response.headers.get("Content-Length") === "0") {
      return response.ok ? { data: void 0, response } : { error: void 0, response };
    }
    if (response.ok) {
      if (parseAs === "stream") {
        return { data: response.body, response };
      }
      return { data: await response[parseAs](), response };
    }
    let error = await response.text();
    try {
      error = JSON.parse(error);
    } catch {
    }
    return { error, response };
  }
  return {
    request(method, url, init) {
      return coreFetch(url, { ...init, method: method.toUpperCase() });
    },
    /** Call a GET endpoint */
    GET(url, init) {
      return coreFetch(url, { ...init, method: "GET" });
    },
    /** Call a PUT endpoint */
    PUT(url, init) {
      return coreFetch(url, { ...init, method: "PUT" });
    },
    /** Call a POST endpoint */
    POST(url, init) {
      return coreFetch(url, { ...init, method: "POST" });
    },
    /** Call a DELETE endpoint */
    DELETE(url, init) {
      return coreFetch(url, { ...init, method: "DELETE" });
    },
    /** Call a OPTIONS endpoint */
    OPTIONS(url, init) {
      return coreFetch(url, { ...init, method: "OPTIONS" });
    },
    /** Call a HEAD endpoint */
    HEAD(url, init) {
      return coreFetch(url, { ...init, method: "HEAD" });
    },
    /** Call a PATCH endpoint */
    PATCH(url, init) {
      return coreFetch(url, { ...init, method: "PATCH" });
    },
    /** Call a TRACE endpoint */
    TRACE(url, init) {
      return coreFetch(url, { ...init, method: "TRACE" });
    },
    /** Register middleware */
    use(...middleware) {
      for (const m of middleware) {
        if (!m) {
          continue;
        }
        if (typeof m !== "object" || !("onRequest" in m || "onResponse" in m || "onError" in m)) {
          throw new Error("Middleware must be an object with one of `onRequest()`, `onResponse() or `onError()`");
        }
        middlewares.push(m);
      }
    },
    /** Unregister middleware */
    eject(...middleware) {
      for (const m of middleware) {
        const i = middlewares.indexOf(m);
        if (i !== -1) {
          middlewares.splice(i, 1);
        }
      }
    }
  };
}
function serializePrimitiveParam(name, value, options) {
  if (value === void 0 || value === null) {
    return "";
  }
  if (typeof value === "object") {
    throw new Error(
      "Deeply-nested arrays/objects aren\u2019t supported. Provide your own `querySerializer()` to handle these."
    );
  }
  return `${name}=${options?.allowReserved === true ? value : encodeURIComponent(value)}`;
}
function serializeObjectParam(name, value, options) {
  if (!value || typeof value !== "object") {
    return "";
  }
  const values = [];
  const joiner = {
    simple: ",",
    label: ".",
    matrix: ";"
  }[options.style] || "&";
  if (options.style !== "deepObject" && options.explode === false) {
    for (const k in value) {
      values.push(k, options.allowReserved === true ? value[k] : encodeURIComponent(value[k]));
    }
    const final2 = values.join(",");
    switch (options.style) {
      case "form": {
        return `${name}=${final2}`;
      }
      case "label": {
        return `.${final2}`;
      }
      case "matrix": {
        return `;${name}=${final2}`;
      }
      default: {
        return final2;
      }
    }
  }
  for (const k in value) {
    const finalName = options.style === "deepObject" ? `${name}[${k}]` : k;
    values.push(serializePrimitiveParam(finalName, value[k], options));
  }
  const final = values.join(joiner);
  return options.style === "label" || options.style === "matrix" ? `${joiner}${final}` : final;
}
function serializeArrayParam(name, value, options) {
  if (!Array.isArray(value)) {
    return "";
  }
  if (options.explode === false) {
    const joiner2 = { form: ",", spaceDelimited: "%20", pipeDelimited: "|" }[options.style] || ",";
    const final = (options.allowReserved === true ? value : value.map((v) => encodeURIComponent(v))).join(joiner2);
    switch (options.style) {
      case "simple": {
        return final;
      }
      case "label": {
        return `.${final}`;
      }
      case "matrix": {
        return `;${name}=${final}`;
      }
      // case "spaceDelimited":
      // case "pipeDelimited":
      default: {
        return `${name}=${final}`;
      }
    }
  }
  const joiner = { simple: ",", label: ".", matrix: ";" }[options.style] || "&";
  const values = [];
  for (const v of value) {
    if (options.style === "simple" || options.style === "label") {
      values.push(options.allowReserved === true ? v : encodeURIComponent(v));
    } else {
      values.push(serializePrimitiveParam(name, v, options));
    }
  }
  return options.style === "label" || options.style === "matrix" ? `${joiner}${values.join(joiner)}` : values.join(joiner);
}
function createQuerySerializer(options) {
  return function querySerializer(queryParams) {
    const search = [];
    if (queryParams && typeof queryParams === "object") {
      for (const name in queryParams) {
        const value = queryParams[name];
        if (value === void 0 || value === null) {
          continue;
        }
        if (Array.isArray(value)) {
          if (value.length === 0) {
            continue;
          }
          search.push(
            serializeArrayParam(name, value, {
              style: "form",
              explode: true,
              ...options?.array,
              allowReserved: options?.allowReserved || false
            })
          );
          continue;
        }
        if (typeof value === "object") {
          search.push(
            serializeObjectParam(name, value, {
              style: "deepObject",
              explode: true,
              ...options?.object,
              allowReserved: options?.allowReserved || false
            })
          );
          continue;
        }
        search.push(serializePrimitiveParam(name, value, options));
      }
    }
    return search.join("&");
  };
}
function defaultPathSerializer(pathname, pathParams) {
  let nextURL = pathname;
  for (const match of pathname.match(PATH_PARAM_RE) ?? []) {
    let name = match.substring(1, match.length - 1);
    let explode = false;
    let style = "simple";
    if (name.endsWith("*")) {
      explode = true;
      name = name.substring(0, name.length - 1);
    }
    if (name.startsWith(".")) {
      style = "label";
      name = name.substring(1);
    } else if (name.startsWith(";")) {
      style = "matrix";
      name = name.substring(1);
    }
    if (!pathParams || pathParams[name] === void 0 || pathParams[name] === null) {
      continue;
    }
    const value = pathParams[name];
    if (Array.isArray(value)) {
      nextURL = nextURL.replace(match, serializeArrayParam(name, value, { style, explode }));
      continue;
    }
    if (typeof value === "object") {
      nextURL = nextURL.replace(match, serializeObjectParam(name, value, { style, explode }));
      continue;
    }
    if (style === "matrix") {
      nextURL = nextURL.replace(match, `;${serializePrimitiveParam(name, value)}`);
      continue;
    }
    nextURL = nextURL.replace(match, style === "label" ? `.${encodeURIComponent(value)}` : encodeURIComponent(value));
  }
  return nextURL;
}
function defaultBodySerializer(body) {
  if (body instanceof FormData) {
    return body;
  }
  return JSON.stringify(body);
}
function createFinalURL(pathname, options) {
  let finalURL = `${options.baseUrl}${pathname}`;
  if (options.params?.path) {
    finalURL = defaultPathSerializer(finalURL, options.params.path);
  }
  let search = options.querySerializer(options.params.query ?? {});
  if (search.startsWith("?")) {
    search = search.substring(1);
  }
  if (search) {
    finalURL += `?${search}`;
  }
  return finalURL;
}
function mergeHeaders(...allHeaders) {
  const finalHeaders = new Headers();
  for (const h of allHeaders) {
    if (!h || typeof h !== "object") {
      continue;
    }
    const iterator = h instanceof Headers ? h.entries() : Object.entries(h);
    for (const [k, v] of iterator) {
      if (v === null) {
        finalHeaders.delete(k);
      } else if (Array.isArray(v)) {
        for (const v2 of v) {
          finalHeaders.append(k, v2);
        }
      } else if (v !== void 0) {
        finalHeaders.set(k, v);
      }
    }
  }
  return finalHeaders;
}
function removeTrailingSlash(url) {
  if (url.endsWith("/")) {
    return url.substring(0, url.length - 1);
  }
  return url;
}

// ../../node_modules/.pnpm/openapi-react-query@0.3.0_@tanstack+react-query@5.69.0_react@18.3.1__openapi-fetch@0.13.4/node_modules/openapi-react-query/dist/index.js
var import_react_query = require("@tanstack/react-query");
function createClient2(client) {
  const queryFn = async ({ queryKey: [method, path, init], signal }) => {
    const mth = method.toUpperCase();
    const fn = client[mth];
    const { data, error } = await fn(path, { signal, ...init });
    if (error) {
      throw error;
    }
    return data;
  };
  const queryOptions2 = (method, path, ...[init, options]) => ({
    queryKey: init === void 0 ? [method, path] : [method, path, init],
    queryFn,
    ...options
  });
  return {
    queryOptions: queryOptions2,
    useQuery: (method, path, ...[init, options, queryClient7]) => (0, import_react_query.useQuery)(queryOptions2(method, path, init, options), queryClient7),
    useSuspenseQuery: (method, path, ...[init, options, queryClient7]) => (0, import_react_query.useSuspenseQuery)(queryOptions2(method, path, init, options), queryClient7),
    useInfiniteQuery: (method, path, init, options, queryClient7) => {
      const { pageParamName = "cursor", ...restOptions } = options;
      const { queryKey } = queryOptions2(method, path, init);
      return (0, import_react_query.useInfiniteQuery)({
        queryKey,
        queryFn: async ({ queryKey: [method2, path2, init2], pageParam = 0, signal }) => {
          const mth = method2.toUpperCase();
          const fn = client[mth];
          const mergedInit = {
            ...init2,
            signal,
            params: {
              ...init2?.params || {},
              query: {
                ...init2?.params?.query,
                [pageParamName]: pageParam
              }
            }
          };
          const { data, error } = await fn(path2, mergedInit);
          if (error) {
            throw error;
          }
          return data;
        },
        ...restOptions
      }, queryClient7);
    },
    useMutation: (method, path, options, queryClient7) => (0, import_react_query.useMutation)({
      mutationKey: [method, path],
      mutationFn: async (init) => {
        const mth = method.toUpperCase();
        const fn = client[mth];
        const { data, error } = await fn(path, init);
        if (error) {
          throw error;
        }
        return data;
      },
      ...options
    }, queryClient7)
  };
}

// src/constants.ts
var API_BASE_URL = process.env.REACT_APP_USER_API_URL || process.env.NEXT_PUBLIC_USER_API_URL || process.env.STORYBOOK_USER_API_URL;

// src/fetchRetry.ts
var import_fetch_retry = __toESM(require_fetch_retry());
var FETCH_RETRIES = 3;
var FETCH_RETRY_DELAY = 1e3;
var retryOn = (attempt, error, response) => {
  const hasStatusToSkipRetry = response?.status && response.status < 500;
  if (!error && hasStatusToSkipRetry) {
    return false;
  }
  if (attempt > FETCH_RETRIES) {
    return false;
  }
  if (error?.name === "AbortError") {
    return false;
  }
  return true;
};
var _fetchRetry = (0, import_fetch_retry.default)(fetch, {
  retries: FETCH_RETRIES,
  retryDelay: FETCH_RETRY_DELAY,
  retryOn
});
var APIOfflineError = class extends Error {
  constructor() {
    super();
    this.name = "OfflineError";
    this.message = "No network was detected on fetch failure";
  }
};
var APIOwnFetchError = class extends Error {
  constructor(_error) {
    super(_error.message, { cause: _error.cause });
    this.name = _error.name;
  }
};
async function fetchRetry(input, init) {
  try {
    return await _fetchRetry(input, init);
  } catch (err) {
    if (typeof window !== "undefined" && window.navigator.onLine === false) {
      throw new APIOfflineError();
    } else if (err instanceof Error) {
      throw new APIOwnFetchError(err);
    } else {
      throw err;
    }
  }
}

// src/middleware.ts
var import_fetchRetry = require("@repo/transport/fetchRetry");
var import_token = require("@repo/transport/token");
var apiFetchMiddleware = {
  onRequest({ request }) {
    const authToken = (0, import_token.getProfileToken)();
    if (authToken && !request.headers.has(import_fetchRetry.HeaderNames.AUTHORIZATION)) {
      request.headers.set(import_fetchRetry.HeaderNames.AUTHORIZATION, `Bearer ${authToken}`);
    }
    return request;
  },
  onError({ error }) {
    if (error instanceof APIOfflineError) {
      return error;
    }
    if (error instanceof Error) {
      return error;
    }
    return new Error("Unknown error");
  }
};

// src/client.ts
var fetchConfig = {
  baseUrl: API_BASE_URL,
  fetch: fetchRetry
};
var apiFetchClient = createClient(fetchConfig);
var apiReactQueryClient = createClient2(apiFetchClient);
apiFetchClient.use(apiFetchMiddleware);

// src/types/helpers.ts
var KittlHeaderNames = /* @__PURE__ */ ((KittlHeaderNames2) => {
  KittlHeaderNames2["WORKSPACE_ID"] = "kittl-workspace-id";
  KittlHeaderNames2["INVITE_ID"] = "kittl-invite-id";
  KittlHeaderNames2["PREVIEW_DEPLOYMENT"] = "kittl-preview-deployment";
  return KittlHeaderNames2;
})(KittlHeaderNames || {});

// src/queries/notifications/useDeleteNotification.ts
var useDeleteNotification = () => {
  return apiReactQueryClient.useMutation(
    "delete",
    "/notifications/{notificationId}"
  );
};

// src/queries/utils/index.ts
var getNextPageParam = (lastPage) => {
  if (!lastPage.success) {
    return lastPage.skip;
  }
  if (lastPage.take + lastPage.skip >= lastPage.total) {
    return null;
  }
  if (lastPage.results.length < lastPage.take) {
    return null;
  }
  return lastPage.skip + lastPage.take;
};

// src/queries/resources/projects/useProjects.ts
var QUERY_METHOD = "get";
var QUERY_PATH = "/designs/index";
var useProjects = (options) => {
  const {
    trash = false,
    folderId = void 0,
    query = void 0,
    sort,
    take,
    // if this isn't set, the backend will use a default value
    workspaceId,
    enabled
  } = options;
  return apiReactQueryClient.useInfiniteQuery(
    QUERY_METHOD,
    QUERY_PATH,
    {
      params: {
        query: {
          folderId,
          take,
          sort,
          trash: trash || void 0,
          query
        },
        headers: {
          ["kittl-workspace-id" /* WORKSPACE_ID */]: workspaceId
        }
      }
    },
    {
      pageParamName: "skip",
      enabled: !!workspaceId && (enabled == null || enabled),
      // we allow the query to be disabled externally
      initialPageParam: 0,
      getNextPageParam,
      // we dont cache designs for now as we
      // want to always show the latest designs
      staleTime: 0,
      gcTime: 0
    }
  );
};

// src/queries/resources/projects/useSharedProjects.ts
var useSharedProjects = (options) => {
  const { take, enabled } = options;
  return apiReactQueryClient.useInfiniteQuery(
    "get",
    "/designs/shared",
    {
      params: {
        query: {
          take
        }
      }
    },
    {
      pageParamName: "skip",
      enabled: enabled === null || enabled,
      // we allow the query to be disabled externally
      initialPageParam: 0,
      getNextPageParam,
      // we dont cache designs for now as we
      // want to always show the latest designs
      staleTime: 0,
      gcTime: 0
    }
  );
};

// src/queries/resources/projects/useRecentProjects.ts
var useRecentProjects = (options) => {
  const { take, enabled } = options;
  return apiReactQueryClient.useInfiniteQuery(
    "get",
    "/designs/recent",
    {
      params: {
        query: {
          take
        }
      }
    },
    {
      pageParamName: "skip",
      enabled: enabled === null || enabled,
      // we allow the query to be disabled externally
      initialPageParam: 0,
      getNextPageParam,
      // we dont cache designs for now as we
      // want to always show the latest designs
      staleTime: 0,
      gcTime: 0
    }
  );
};

// src/queries/resources/workspaces/useWorkspaceQuery.ts
var import_queries = require("@repo/transport/queries");
var import_collection = require("@repo/utils/collection");
var select = (data) => {
  if (data.success) {
    return data.workspace;
  }
  return void 0;
};
var useWorkspaceQuery = ({
  workspaceId,
  enabled
}) => {
  return apiReactQueryClient.useQuery(
    "get",
    "/workspaces/{workspaceId}",
    {
      params: { path: { workspaceId: workspaceId ?? "" } }
    },
    { select, enabled: !!workspaceId && (enabled === void 0 || enabled) }
    // enabled by default
  );
};
function patchWorkspaceQuery(patchEntry) {
  const queryKey = [
    "get",
    "/workspaces/{workspaceId}",
    { params: { path: { workspaceId: patchEntry.id } } }
  ];
  const cacheData = import_queries.queryClient.getQueryData(queryKey)?.workspace;
  if (cacheData) {
    import_queries.queryClient.setQueryData(queryKey, {
      success: true,
      workspace: (0, import_collection.partialMerge)({ ...cacheData }, patchEntry)
    });
    return;
  }
  import_queries.queryClient.invalidateQueries({ queryKey });
}
function invalidateWorkspaceQuery(workspaceId) {
  const queryKey = [
    "get",
    "/workspaces/{workspaceId}",
    { params: { path: { workspaceId } } }
  ];
  import_queries.queryClient.invalidateQueries({ queryKey });
}

// src/queries/resources/workspaces/useWorkspacesForUserQuery.ts
var import_queries2 = require("@repo/transport/queries");
var import_collection2 = require("@repo/utils/collection");
var import_react_query2 = require("@tanstack/react-query");
var select2 = (data) => {
  if (data.success) {
    return data.workspaces;
  }
  return void 0;
};
var queryOptions = apiReactQueryClient.queryOptions(
  "get",
  "/workspaces/index",
  {},
  {
    select: select2
  }
);
var useWorkspacesForUserQuery = () => {
  return (0, import_react_query2.useQuery)(queryOptions, import_queries2.queryClient);
};
function patchQueryCache(entry) {
  const cacheData = import_queries2.queryClient.getQueryData(
    queryOptions.queryKey
  )?.workspaces;
  if (cacheData) {
    const newArray = (0, import_collection2.patchArrayEntry)(cacheData, entry);
    if (newArray) {
      import_queries2.queryClient.setQueryData(queryOptions.queryKey, {
        success: true,
        workspaces: newArray
      });
      return;
    }
  }
  import_queries2.queryClient.invalidateQueries({ queryKey: queryOptions.queryKey });
}
var invalidateWorkspacesForUserQuery = () => {
  import_queries2.queryClient.invalidateQueries({
    queryKey: queryOptions.queryKey
  });
};

// src/queries/resources/workspaces/useCreateWorkspaceMutation.ts
var import_queries3 = require("@repo/transport/queries");
var useCreateWorkspaceMutation = () => {
  return apiReactQueryClient.useMutation(
    "post",
    "/workspaces/create",
    {
      onSuccess: invalidateWorkspacesForUserQuery
    },
    import_queries3.queryClient
  );
};

// src/queries/resources/workspaces/useUpdateWorkspaceMutation.ts
var useUpdateWorkspaceMutation = () => {
  return apiReactQueryClient.useMutation("patch", "/workspaces/{workspaceId}", {
    onSuccess: (_, variables) => {
      const workspaceId = variables.params.path.workspaceId;
      const patchEntry = { ...variables.body, id: workspaceId };
      patchQueryCache(patchEntry);
      patchWorkspaceQuery(patchEntry);
    }
  });
};

// src/queries/resources/workspaces/useDeleteWorkspaceMutation.ts
var import_queries4 = require("@repo/transport/queries");
var useDeleteWorkspaceMutation = () => {
  return apiReactQueryClient.useMutation(
    "delete",
    "/workspaces/{workspaceId}",
    {
      onSuccess: (_, variable) => {
        import_queries4.queryClient.invalidateQueries({
          queryKey: queryOptions.queryKey
        });
        invalidateWorkspaceQuery(variable.params.path.workspaceId);
      }
    }
  );
};

// src/queries/resources/workspaces/getWorkspaceMe.ts
var getWorkspaceMe = async () => {
  const response = await apiFetchClient.GET("/workspaces/me");
  if (response.error) {
    throw response.error;
  }
  return response.data;
};

// src/queries/resources/workspaces/getWorkspaceById.ts
var getWorkspaceById = async (workspaceId) => {
  const response = await apiFetchClient.GET("/workspaces/{workspaceId}", {
    params: { path: { workspaceId } }
  });
  if (response.error) {
    throw response.error;
  }
  return response.data;
};

// src/queries/resources/folders/useFolders.ts
var QUERY_METHOD2 = "get";
var QUERY_PATH2 = "/folders/index";
var useFolders = (options) => {
  const {
    folderId = void 0,
    query = void 0,
    sort,
    take,
    // if this isn't set, the backend will use a default value
    workspaceId,
    enabled
  } = options;
  return apiReactQueryClient.useInfiniteQuery(
    QUERY_METHOD2,
    QUERY_PATH2,
    {
      params: {
        query: {
          folderId,
          take,
          sort,
          query
        },
        headers: {
          ["kittl-workspace-id" /* WORKSPACE_ID */]: workspaceId
        }
      }
    },
    {
      pageParamName: "skip",
      enabled: !!workspaceId && (enabled == null || enabled),
      // we allow the query to be disabled externally
      initialPageParam: 0,
      getNextPageParam,
      // we dont cache folders for now as we
      // want to always show the latest folders
      staleTime: 0,
      gcTime: 0
    }
  );
};

// src/queries/permissions/useResourcePermissionsQuery.ts
var ResourcePermissions = /* @__PURE__ */ ((ResourcePermissions2) => {
  ResourcePermissions2["ADMIN"] = "admin";
  ResourcePermissions2["VIEW"] = "view";
  ResourcePermissions2["EDIT"] = "edit";
  ResourcePermissions2["DELETE"] = "delete";
  ResourcePermissions2["COMMENT_VIEW"] = "comment_view";
  ResourcePermissions2["COMMENT_CREATE"] = "comment_create";
  ResourcePermissions2["INVITE_VIEW"] = "invite_view";
  ResourcePermissions2["INVITE_CREATE"] = "invite_create";
  ResourcePermissions2["RESOLVE"] = "resolve";
  ResourcePermissions2["RESEND"] = "resend";
  ResourcePermissions2["DESIGN_VIEW"] = "design_view";
  ResourcePermissions2["DESIGN_EDIT"] = "design_edit";
  ResourcePermissions2["DESIGN_DELETE"] = "design_delete";
  ResourcePermissions2["DESIGN_CREATE"] = "design_create";
  ResourcePermissions2["ASSET_VIEW"] = "asset_view";
  ResourcePermissions2["ASSET_EDIT"] = "asset_edit";
  ResourcePermissions2["ASSET_DELETE"] = "asset_delete";
  ResourcePermissions2["ASSET_CREATE"] = "asset_create";
  ResourcePermissions2["BILLING_ADMIN"] = "billing_admin";
  return ResourcePermissions2;
})(ResourcePermissions || {});
var PERMISSION_LOOKUP = {
  [ResourceType.presentation]: [
    "edit" /* EDIT */,
    "view" /* VIEW */,
    "invite_create" /* INVITE_CREATE */,
    "invite_view" /* INVITE_VIEW */,
    "admin" /* ADMIN */,
    "comment_create" /* COMMENT_CREATE */,
    "comment_view" /* COMMENT_VIEW */
  ],
  [ResourceType.design]: [
    "edit" /* EDIT */,
    "view" /* VIEW */,
    "invite_create" /* INVITE_CREATE */,
    "invite_view" /* INVITE_VIEW */,
    "admin" /* ADMIN */,
    "comment_create" /* COMMENT_CREATE */,
    "comment_view" /* COMMENT_VIEW */
  ],
  [ResourceType.workspace]: [
    "admin" /* ADMIN */,
    "view" /* VIEW */,
    "billing_admin" /* BILLING_ADMIN */,
    "design_view" /* DESIGN_VIEW */,
    "design_edit" /* DESIGN_EDIT */,
    "design_delete" /* DESIGN_DELETE */,
    "design_create" /* DESIGN_CREATE */,
    "asset_view" /* ASSET_VIEW */,
    "asset_edit" /* ASSET_EDIT */,
    "asset_delete" /* ASSET_DELETE */,
    "asset_create" /* ASSET_CREATE */,
    "invite_create" /* INVITE_CREATE */,
    "invite_view" /* INVITE_VIEW */
  ]
};
var useResourcePermissionsQuery = ({
  resourceType,
  resourceId,
  inviteId
}) => {
  return apiReactQueryClient.useQuery(
    "get",
    "/sessions/access/{resourceType}/{id}",
    {
      params: {
        path: {
          resourceType,
          id: resourceId ?? ""
        },
        query: {
          permissions: PERMISSION_LOOKUP[resourceType]?.toString() ?? "",
          inviteId
        }
      }
    },
    {
      enabled: !!resourceId
    }
  );
};

// src/queries/user/useBasicUserInfoQuery.ts
var useBasicUserInfoQuery = () => {
  return apiReactQueryClient.useQuery("get", "/users/basic");
};

// src/queries/collaboration/useCollaborationInvitesQuery.ts
var import_queries5 = require("@repo/transport/queries");
var useCollaborationInvitesQuery = (queryParams) => {
  return apiReactQueryClient.useInfiniteQuery(
    "get",
    "/collaboration/invites",
    {
      params: { query: queryParams }
    },
    {
      enabled: !!queryParams.resourceId && !!queryParams.resourceType,
      initialPageParam: "",
      getNextPageParam: ({ cursor }) => cursor
    }
  );
};
var invalidateCollaborationInvitesQuery = () => {
  import_queries5.queryClient.invalidateQueries({
    queryKey: ["get", "/collaboration/invites"]
  });
};

// src/queries/collaboration/useCollaborationInvitesCreateMutation.ts
var import_queries6 = require("@repo/transport/queries");
var useCollaborationInvitesCreateMutation = () => {
  return apiReactQueryClient.useMutation(
    "post",
    "/collaboration/invites",
    {
      onSuccess: () => {
        invalidateCollaborationInvitesQuery();
      }
    },
    import_queries6.queryClient
  );
};

// src/queries/collaboration/useCollaborationInvitesRevokeMutation.ts
var useCollaborationInvitesRevokeMutation = () => {
  return apiReactQueryClient.useMutation(
    "delete",
    "/collaboration/invites/{inviteId}",
    {
      onSuccess: () => {
        invalidateCollaborationInvitesQuery();
      }
    }
  );
};

// src/queries/collaboration/useCollaborationInvitesResendMutation.ts
var useCollaborationInvitesResendMutation = () => {
  return apiReactQueryClient.useMutation(
    "post",
    "/collaboration/invites/{inviteId}/resend",
    {
      onSuccess: () => {
        invalidateCollaborationInvitesQuery();
      }
    }
  );
};

// src/queries/collaboration/useCollaborationInvitesPatchMutation.ts
var useCollaborationInvitesPatchMutation = () => {
  return apiReactQueryClient.useMutation(
    "patch",
    "/collaboration/invites/{inviteId}",
    {
      onSuccess: () => {
        invalidateCollaborationInvitesQuery();
      }
    }
  );
};

// src/queries/credits/useCreditsInfo.ts
var useCreditsInfo = () => {
  return apiReactQueryClient.useQuery("get", "/users/balance", {})?.data;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  APIOfflineError,
  APIOwnFetchError,
  AccessRole,
  CMSTemplateObjectReviewState,
  DesignSortType,
  FolderSortType,
  InvitableResourceTypes,
  KittlHeaderNames,
  PathsAiartIndexGetParametersQuerySort,
  PathsAiartIndexGetParametersQueryStyleId,
  PathsAiartIndexGetResponses200ContentApplicationJsonResultsReviewState,
  PathsAiartSearchGetParametersQueryType,
  PathsBillingCheckoutCreatePostResponses200ContentApplicationJsonLinkName,
  PathsBookmarksCreatePostRequestBodyApplicationJsonBookmarkType,
  PathsChallengesList_submissionsGetParametersQuerySort,
  PathsCmsTemplatesEditorialFilterGetParametersQueryFilterType,
  PathsCmsTemplatesIndexPostParametersQuerySortBy,
  PathsCmsTemplatesIndexPostParametersQuerySortOrder,
  PathsCmsWorkspacesIndexGetParametersQueryType,
  PathsCmsWorkspacesIndexGetResponses200ContentApplicationJsonResultsOwnerType,
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionChangesAction,
  PathsCmsWorkspacesWorkspaceIdGetResponses200ContentApplicationJsonSubscriptionStatus,
  PathsCollaborationInvitesGetParametersQueryResourceType,
  PathsCollaborationInvitesInviteIdPatchRequestBodyApplicationJsonRole,
  PathsContentusesCreatePostRequestBodyApplicationXWwwFormUrlencodedType,
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonTone,
  PathsCopilotGenerateTextPostRequestBodyApplicationJsonType,
  PathsDesignsDesignIdPresentationsPostResponses201ContentApplicationJsonPresentationSharing,
  PathsDesignsDesignIdPresentationsPresentationIdInvitesGetResponses200ContentApplicationJsonResultsReceiverRole,
  PathsDesignsDesignIdPresentationsPresentationIdInvitesPostRequestBodyApplicationJsonUsersRole,
  PathsDesignsDesignIdThreadsCommentsCommentIdReactionsPostRequestBodyApplicationJsonEmoji,
  PathsDesignsDesignIdThreadsGetParametersQueryFilter,
  PathsDesignsSharedGetResponses200ContentApplicationJsonResultsType,
  PathsElementsSearchPostRequestBodyApplicationJsonFilterAccessLevel,
  PathsElementsSearchPostRequestBodyApplicationJsonFilterFormat,
  PathsElementsUsePostRequestBodyApplicationJsonElementType,
  PathsElementsUsePostRequestBodyApplicationJsonFeature,
  PathsFeature_groupsAddPostResponses404ContentApplicationJsonError,
  PathsFoldersIndexGetResponses200ContentApplicationJsonResultsType,
  PathsGeneratorsDesignsPostResponses201ContentApplicationJsonResultsBackend,
  PathsGeneratorsImagePostRequestBodyApplicationJsonActionOrigin,
  PathsGeneratorsImagePostRequestBodyApplicationJsonAspectRatio,
  PathsGeneratorsImagePostResponses201ContentApplicationJsonStatus,
  PathsGeneratorsVectorizePostRequestBodyApplicationJsonSolver,
  PathsLibrariesLibraryIdPresetsCreatePostRequestBodyApplicationXWwwFormUrlencodedType,
  PathsLibrariesLibraryIdPresetsIndexGetParametersQuerySort,
  PathsPathsCreatePostRequestBodyApplicationJsonType,
  PathsPaymentIdFailure_reasonGetResponses200ContentApplicationJsonIntentErrorCode,
  PathsPerformanceMetricsIngestPostRequestBodyApplicationJsonDataMetricName,
  PathsPostsForYouGetParametersQueryAlgorithm,
  PathsPostsV1ExploreGetParametersQuerySort,
  PathsProductsIndexGetParametersQueryType,
  PathsProductsIndexGetResponses200ContentApplicationJsonProductsType,
  PathsPromptstylesCreatePostResponses201ContentApplicationJsonPromptStyleGroupsType,
  PathsResourcesSharedGetParametersQueryResourceType,
  PathsShareCreatePostRequestBodyApplicationXWwwFormUrlencodedEditable,
  PathsSubscriptionAdminChangePostRequestBodyApplicationJsonPlan,
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataStripeAccountCountry,
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval,
  PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesPlan,
  PathsSurveysResponseSubmitPostRequestBodyApplicationJsonType,
  PathsUsersAdminUpdate_rolePostRequestBodyApplicationJsonBodyRole,
  PathsUsersAnswer_questionnairePostResponses400ContentApplicationJsonError,
  PathsUsersBalancePostResponses200ContentApplicationJsonDataRecurringType,
  PathsUsersClaim_onboarding_checklist_rewardPostResponses400ContentApplicationJsonError,
  PathsUsersUserIdAttributesGetResponses200ContentApplicationJsonDataName,
  PostObjectType,
  ResourcePermissions,
  ResourceType,
  SubscriptionObjectFreeTrialStatus,
  SubscriptionPlanObjectInterval,
  apiFetchClient,
  apiReactQueryClient,
  getWorkspaceById,
  getWorkspaceMe,
  invalidateEndpointCache,
  invalidateWorkspaceQuery,
  invalidateWorkspacesForUserQuery,
  useBasicUserInfoQuery,
  useCollaborationInvitesCreateMutation,
  useCollaborationInvitesPatchMutation,
  useCollaborationInvitesQuery,
  useCollaborationInvitesResendMutation,
  useCollaborationInvitesRevokeMutation,
  useCreateWorkspaceMutation,
  useCreditsInfo,
  useDeleteNotification,
  useDeleteWorkspaceMutation,
  useFolders,
  useProjects,
  useRecentProjects,
  useResourcePermissionsQuery,
  useSharedProjects,
  useUpdateWorkspaceMutation,
  useWorkspaceQuery,
  useWorkspacesForUserQuery,
  workspacesForUserQueryOptions
});
